import globals from 'Js/common/globals';
import getDateFormattedParts from './getDateFormattedParts';

export const STANDARD_PERIOD_START_HOUR = 15; // 15:00
export const STANDARD_PERIOD_END_HOUR = 7; // 7:00

/**
 * Функция возвращает флаг – входит ли текущее время в диапазон,
 * когда действия в складах/магазинах/настройках аккаунта влекут за собой
 * повышение цены клика до стандартного тарифа PBI#110638
 */
export const isStandardClickPeriod = () => {
    // Период стандартного клика актуален только для RU и UA версий
    if (
        !globals.featureFlags.get('IsAvtopro') &&
        !globals.featureFlags.get('IsAvtoproUa')
    )
        return false;

    // Для новых юзеров которые проходят по степперу политика применяется через 7 дней после создания бизнес-аккаунта
    const becomeSellerDate = new Date(globals.user.becomeSellerDate);
    becomeSellerDate.setDate(becomeSellerDate.getDate() + 7);
    if (new Date() < becomeSellerDate) return false;

    const currentTime = getDateFormattedParts('Europe/Kyiv');

    const seconds =
        currentTime.hours * 3600 +
        currentTime.minutes * 60 +
        currentTime.seconds;

    return (
        seconds >= STANDARD_PERIOD_START_HOUR * 3600 ||
        seconds <= STANDARD_PERIOD_END_HOUR * 3600
    );
};
